"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@csod/assets/assets/normalize.css");
require("@csod/assets/assets/csod-icons.css");
require("@csod/assets/assets/csod-style-utilities.css");
require("player-theming/theme.css");
var utils_1 = require("player-core/utils");
exports.createUUID = utils_1.createUUID;
var portal_position_1 = require("player-react-portal/build/portal-position");
exports.positionDropdown = portal_position_1.positionDropdown;
var player_react_portal_1 = require("player-react-portal");
exports.Portal = player_react_portal_1.Portal;
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/predictive-search/build/__exports.js
// module id = 576
// module chunks = 0